import React, { useState } from 'react';
import './styles/global.css';
import { Search, History, Key, Layers } from 'lucide-react';
import { ToastProvider } from './hooks/useToast';
import SearchPage from './pages/SearchPage';
import HistoryPage from './pages/HistoryPage';
import AdminModal from './components/AdminModal';

function Navbar({ activePage, setActivePage, onAdminOpen }) {
  return (
    <nav className="navbar">
      <div className="brand">
        <div className="brand-icon-box">
          <Layers size={18} />
        </div>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <span className="brand-name">Lead Forge</span>
            <span className="brand-tag">v2.0</span>
          </div>
        </div>
      </div>

      <div className="nav-links">
        <button
          id="nav-search"
          type="button"
          className={`nav-btn ${activePage === 'search' ? 'active' : ''}`}
          onClick={() => setActivePage('search')}
        >
          <Search size={15} />
          <span>Extractor</span>
        </button>

        <button
          id="nav-history"
          type="button"
          className={`nav-btn ${activePage === 'history' ? 'active' : ''}`}
          onClick={() => setActivePage('history')}
        >
          <History size={15} />
          <span>History</span>
        </button>

        <button
          id="nav-admin"
          type="button"
          className="nav-btn nav-btn-admin"
          onClick={onAdminOpen}
        >
          <Key size={15} color="var(--color-indigo)" />
          <span>API Keys</span>
        </button>
      </div>
    </nav>
  );
}

function App() {
  const [activePage, setActivePage] = useState('search');
  const [showAdmin, setShowAdmin] = useState(false);

  return (
    <ToastProvider>
      <div className="app-container">
        <Navbar
          activePage={activePage}
          setActivePage={setActivePage}
          onAdminOpen={() => setShowAdmin(true)}
        />

        <main className="main-content">
          {activePage === 'search' && <SearchPage />}
          {activePage === 'history' && <HistoryPage />}
        </main>

        <AdminModal
          isOpen={showAdmin}
          onClose={() => setShowAdmin(false)}
        />
      </div>
    </ToastProvider>
  );
}

export default App;
